module.exports = __webpack_public_path__ + "img/product-sm-5.144277a9.png";